import { TypographyOptions } from "@mui/material/styles/createTypography";

export const typography: TypographyOptions = {
  fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"].join(","),
  fontSize: 13,
  fontWeightLight: "300",
  fontWeightRegular: "400",
  fontWeightMedium: "500",
  fontWeightBold: "700",
  htmlFontSize: 16,
  h7: {
    fontSize: "1.2rem",
    fontWeight: "bold",
  },
};

declare module "@mui/material/styles" {
  interface TypographyVariants {
    h7: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    h7?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    h7: true;
  }
}
